import type { CSSVariablesResolver } from "@mantine/core";

export const mantineCssVariableResolver: CSSVariablesResolver = (theme) => ({
    variables: {
        // Variables that do not depend on color scheme
        '--spotter-border-radius': theme.radius.md,
        '--spotter-shadow': theme.shadows.xl,
    },
    light: {
        // Variables for light color scheme only
        '--spotter-bg-primary': '#ffffff',
        '--spotter-bg-secondary': '#f8f9fa',
        '--spotter-text-primary': '#000000',
        '--spotter-text-secondary': '#6c757d',
        '--spotter-border-color': '#e9ecef',
    },
    dark: {
        // Variables for dark color scheme only
        '--spotter-bg-primary': '#1a1b1e',
        '--spotter-bg-secondary': '#25262b',
        '--spotter-text-primary': '#ffffff',
        '--spotter-text-secondary': '#a6a7ab',
        '--spotter-border-color': '#373a40',
    },
});
